module.exports = "query Tags ($limit: Int = 10000, $asc: String, $desc: String, $status: String, $in_media: Boolean = false) {\n  tagList (limit: $limit, asc: $asc, desc: $desc, status: $status, in_media: $in_media) {\n    id\n    name\n    slug\n    status\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/graphQL/queries/TagList.graphql
// module id = 1VbI
// module chunks = 1624